import { lazy } from "react";

// Imports => Constants
import { ICONS } from "@opp/ui-kit";

// Imports => Utilities
import { AcUUID } from "@opp/ui-kit";

const AcAuthenticate = lazy(
  () =>
    /* webpackChunkName: "AcAuthenticate" */
    import("@views/ac-authenticate/ac-authenticate")
);
const AcLogin = lazy(
  () => import(/* webpackChunkName: "AcLogin" */ "@views/ac-login/ac-login")
);
const AcProfile = lazy(
  () =>
    import(/* webpackChunkName: "AcProfile" */ "@views/ac-profile/ac-profile")
);
const AcChangelog = lazy(
  () =>
    import(
      /* webpackChunkName: "AcChangelog" */ "@views/ac-changelog/ac-changelog"
    )
);
const AcDashboard = lazy(
  () =>
    import(
      /* webpackChunkName: "AcDashboard" */ "@views/ac-dashboard/ac-dashboard"
    )
);
const AcSettlementsOverview = lazy(
  () =>
    import(
      /* webpackChunkName: "AcSettlementsOverview" */ "@views/ac-settlements-overview/ac-settlements-overview"
    )
);
const AcSettlementDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "AcSettlementDetails" */ "@views/ac-settlement-details/ac-settlement-details"
    )
);
const AcTransactionsOverview = lazy(
  () =>
    import(
      /* webpackChunkName: "AcTransactionsOverview" */ "@views/ac-transactions-overview/ac-transactions-overview"
    )
);
const AcTransactionDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "AcTransactionDetails" */ "@views/ac-transaction-details/ac-transaction-details"
    )
);
const AcMovementDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "AcMovementDetails" */ "@views/ac-movement-details/ac-movement-details"
    )
);
const AcWithdrawalDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "AcWithdrawalDetails" */ "@views/ac-withdrawal-details/ac-withdrawal-details"
    )
);
const AcPurchasesOverview = lazy(
  () =>
    import(
      /* webpackChunkName: "AcPurchasesOverview" */ "@views/ac-purchases-overview/ac-purchases-overview"
    )
);
const AcPurchaseDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "AcPurchaseDetails" */ "@views/ac-purchase-details/ac-purchase-details"
    )
);
const AcSupportOverview = lazy(
  () =>
    import(
      /* webpackChunkName: "AcSupportOverview" */ "@views/ac-support-overview/ac-support-overview"
    )
);

const AcPaymentLink = lazy(
  () =>
    import(
      /* webpackChunkName: "AcSupportOverview" */ "@views/ac-payment-links"
    )
);

const AcModulesPage = lazy(
  () => import(/* webpackChunkName: "AcModules" */ "@views/ac-modules")
);

export const PATHS = {
  AUTHENTICATE: "/authenticate",
  LOGIN: "/login",
  PROFILE: "/profile",
  SETTINGS: "/profile#settings",
  SECURITY: "/profile#security",
  CHANGELOG: "/whats-new",
  DASHBOARD: "/dashboard",
  SETTLEMENTS: "/settlements",
  SETTLEMENT_DETAILS: "/settlements/:id",
  TRANSACTIONS: "/transactions",
  TRANSACTION_DETAILS: "/transactions/:id",
  MOVEMENT_DETAILS: "/movements/:id",
  WITHDRAWAL_DETAILS: "/withdrawals/:id",
  PURCHASES: "/purchases",
  PURCHASE_DETAILS: "/purchases/:id",
  SUPPORT_OVERVIEW: "/support",
  PAYMENT_LINKS: "/payment-links",
  MODULES: "/modules",
};

export const ROUTES = {
  AUTHENTICATE: {
    id: AcUUID(),
    name: "Authenticate",
    label: null,
    path: PATHS.AUTHENTICATE,
    component: AcAuthenticate,
    allowed: null,
    forbidden: false,
    exact: true,
  },
  LOGIN: {
    id: AcUUID(),
    name: "Login",
    label: null,
    path: PATHS.LOGIN,
    component: AcLogin,
    allowed: null,
    forbidden: false,
    exact: true,
  },
  PROFILE: {
    id: AcUUID(),
    name: "Profile",
    label: "TITLES.PROFILE",
    path: PATHS.PROFILE,
    component: AcProfile,
    icon: ICONS.USER,
    allowed: null,
    forbidden: true,
    exact: true,
  },
  SETTINGS: {
    id: AcUUID(),
    name: "Settings",
    label: "TITLES.SETTINGS",
    path: PATHS.SETTINGS,
    component: AcProfile,
    icon: ICONS.SETTINGS,
    allowed: null,
    forbidden: true,
    exact: true,
  },
  SECURITY: {
    id: AcUUID(),
    name: "Security",
    label: "TITLES.SECURITY",
    path: PATHS.SECURITY,
    component: AcProfile,
    icon: ICONS.LOCK_OUTLINE,
    allowed: null,
    forbidden: true,
    exact: true,
  },
  CHANGELOG: {
    id: AcUUID(),
    name: "Changelog",
    label: "TITLES.CHANGELOG",
    path: PATHS.CHANGELOG,
    component: AcChangelog,
    icon: ICONS.LIST_BULLETED,
    allowed: null,
    forbidden: true,
    exact: true,
    disabled: true,
  },
  DASHBOARD: {
    id: AcUUID(),
    name: "Dashboard",
    label: "TITLES.DASHBOARD",
    path: PATHS.DASHBOARD,
    component: AcDashboard,
    icon: ICONS.GAMEPAD_TILTED_OUTLINE,
    allowed: null,
    forbidden: true,
    exact: true,
  },
  TRANSACTIONS_OVERVIEW: {
    id: AcUUID(),
    name: "Transactions Overview",
    label: "TITLES.TRANSACTIONS",
    path: PATHS.TRANSACTIONS,
    component: AcTransactionsOverview,
    icon: ICONS.TRANSACTIONS,
    allowed: null,
    forbidden: true,
    exact: true,
  },
  TRANSACTION_DETAILS: {
    id: AcUUID(),
    name: "Transaction Details",
    label: "TITLES.TRANSACTION",
    path: PATHS.TRANSACTION_DETAILS,
    component: AcTransactionDetails,
    icon: null,
    allowed: null,
    forbidden: true,
    exact: true,
  },
  MOVEMENT_DETAILS: {
    id: AcUUID(),
    name: "Transaction Details",
    label: "TITLES.TRANSACTION",
    path: PATHS.MOVEMENT_DETAILS,
    component: AcMovementDetails,
    icon: null,
    allowed: null,
    forbidden: true,
    exact: true,
  },
  WITHDRAWAL_DETAILS: {
    id: AcUUID(),
    name: "Transaction Details",
    label: "TITLES.TRANSACTION",
    path: PATHS.WITHDRAWAL_DETAILS,
    component: AcWithdrawalDetails,
    icon: null,
    allowed: null,
    forbidden: true,
    exact: true,
  },
  PURCHASES_OVERVIEW: {
    id: AcUUID(),
    name: "Purchases Overview",
    label: "TITLES.PURCHASES",
    path: PATHS.PURCHASES,
    component: AcPurchasesOverview,
    icon: ICONS.SHOPPING_CART,
    allowed: null,
    forbidden: true,
    exact: true,
  },
  PURCHASE_DETAILS: {
    id: AcUUID(),
    name: "Purchase Details",
    label: "TITLES.PURCHASE",
    path: PATHS.PURCHASE_DETAILS,
    component: AcPurchaseDetails,
    icon: null,
    allowed: null,
    forbidden: true,
    exact: true,
  },
  SETTLEMENTS_OVERVIEW: {
    id: AcUUID(),
    name: "Settlements Overview",
    label: "TITLES.SETTLEMENTS",
    path: PATHS.SETTLEMENTS,
    component: AcSettlementsOverview,
    icon: ICONS.BANK_OUTLINE,
    allowed: null,
    forbidden: true,
    exact: true,
  },
  SETTLEMENT_DETAILS: {
    id: AcUUID(),
    name: "Settlement Details",
    label: "TITLES.SETTLEMENT",
    path: PATHS.SETTLEMENT_DETAILS,
    component: AcSettlementDetails,
    icon: null,
    allowed: null,
    forbidden: true,
    exact: true,
  },
  MODULES: {
    id: AcUUID(),
    name: "Modules Overview",
    label: "TITLES.MODULES_PAGE",
    path: PATHS.MODULES,
    component: AcModulesPage,
    icon: ICONS.APPS,
    allowed: null,
    forbidden: true,
    exact: true,
  },
  SUPPORT_OVERVIEW: {
    id: AcUUID(),
    name: "Support Overview",
    label: "TITLES.SUPPORT_OVERVIEW",
    path: PATHS.SUPPORT_OVERVIEW,
    component: AcSupportOverview,
    icon: ICONS.SUPPORT,
    allowed: null,
    forbidden: true,
    exact: true,
  },
  PAYMENT_LINKS: {
    id: AcUUID(),
    name: "Support Overview",
    label: "TITLES.PAYMENT_LINKS",
    path: PATHS.PAYMENT_LINKS,
    component: AcPaymentLink,
    icon: ICONS.SEND,
    allowed: null,
    forbidden: true,
    exact: true,
  },
};

export const AUTHENTICATION_ROUTES = [
  ROUTES.LOGIN.path,
  ROUTES.AUTHENTICATE.path,
];

export const NAVIGATION_ROUTES = [
  ROUTES.DASHBOARD,
  ROUTES.TRANSACTIONS_OVERVIEW,
  ROUTES.SETTLEMENTS_OVERVIEW,
  ROUTES.PURCHASES_OVERVIEW,
  ROUTES.SUPPORT_OVERVIEW,
  ROUTES.MODULES,
];

export const DASHBOARD_ROUTES = {};

export const DEFAULT_ROUTE = ROUTES.DASHBOARD;
export const REDIRECT_ROUTE = ROUTES.LOGIN;
